
import s from '../docs.module.css'
import SaveStatus from '../../../UIComponents/SaveStatus';
import DocsSecondTableTC from "../DocsSecond/DocsSecondTable.jsx";
import RadioGroup from "../../baseComponents/RadioGroup/RadioGroup.jsx";


const DocsRight = ({ data = [], loaderInfoSource }) => {
    return (
        <div className={s.docsContainer}>

            <RadioGroup />
            {/* <span className={s.time}>
                <a href="">Выбрать время</a>
            </span> */}
            <div className={s.secondRightConrainer}>
                <div className={s.contentContainer}>
                    <SaveStatus errShowTime={1000} successShowTime={500} dataObj={loaderInfoSource} title="Загрузка данных" />
                </div>
            </div>
            <div className={s.contentContainer}>
                {data.map((widget) => (
                    <div className={s.containerItem}>
                        <DocsSecondTableTC {...widget} />
                    </div>
                ))}

                {/*<BodyRight/>*/}
            </div>
        </div>
    );
};

export default DocsRight;